import React from 'react';
import './ComprarMoto.css';
import motoImage from '../../images/staticas/motos.png'; // 👈 ¡La importación ya estaba bien!
import { Link } from 'react-router-dom'; // 👈 Import necesario
import LazyImage from '../LazyImage';

export default function ComprarMoto() {
    const handleMotosClick = () => {
        // Aquí puedes manejar la navegación a la página de motos
        console.log('Navegando a página de motos (próximamente)');
        // Ejemplo: navigate('/motos');
    };

    return (
        <div className='comprar-moto-section'>
            <div className='comprar-moto-container'>
                <div className='comprar-moto-content'>
                    <div className='comprar-moto-text'>
                        <h2 className='comprar-moto-title'>TU PROXIMA MOTO EN FILONI</h2>
                        <p className='comprar-moto-description'>
                            En FILONI Auto contamos con motos seleccionadas y listas para vos. Encontrá la que más te guste y nosotros nos encargamos del resto.
                        </p>
                        <ul className='comprar-moto-features'>
                            <li>Las mejores motos del mercado</li>
                            <li>Financiación rápida y conveniente.</li>
                            <li>Hacemos del proceso lo más sencillo.</li>
                        </ul>
                        <div className='comprar-moto-button-container'>
                            <Link to="/stock/motos" style={{ color: 'white', textDecoration: 'none' }}>
                                Ver Motos disponibles
                            </Link>

                        </div>

                    </div>

                    <div className='comprar-moto-image'>
                        <LazyImage
                            src={motoImage} // 👈 ¡CORRECCIÓN: Usamos la variable importada!
                            alt="Motos disponibles"
                            className='moto-img'
                        />
                    </div>

                </div>
            </div>
        </div >
    );
}